module.exports = __webpack_public_path__ + "static/media/logo.b7d89920.png";